const BuilderConstants = {
    CONSTRUCT: "CONSTRUCT",
    PUBLISH: "PUBLISH",
    ACTIVE: "ACTIVE"
};

export default BuilderConstants;
